export default __webpack_public_path__ + "static/media/Icon-code.dc24c557.svg";